export const LIFE_INSURANCE_YES = 'YES';
export const LIFE_INSURANCE_NO = 'NO';
export const INCLUDE_LIFE_INSURANCE = 1;
export const UNINCLUDE_LIFE_INSURANCE = 0;
export const MILLION = 1000000;
export const PERCENT = 100;
export const TOTAL_MONTH = 12;
export const MIN_AMOUNT_NUMBER = 5;
export const LIMIT_MAX_AMOUNT_NUMBER = 26;
export const LIMIT_MIN_AMOUNT = 0.9;
export const STEP = 1;
